import { render, staticRenderFns } from "./HomeworkPreviewQuestion.vue?vue&type=template&id=70ebf7f6&scoped=true&"
import script from "./HomeworkPreviewQuestion.vue?vue&type=script&lang=js&"
export * from "./HomeworkPreviewQuestion.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkPreviewQuestion.vue?vue&type=style&index=0&id=70ebf7f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ebf7f6",
  null
  
)

export default component.exports